<template>
  <div className="xr-editor">
    <quill-editor
      v-model="content"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
    />
  </div>
</template>

<script>
import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'XrEditor',
  components: {
    quillEditor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      content: this.value,
      editorOption: {
        theme: 'snow',
        modules: {
          toolbar: [
            // 第一行
            ['bold', 'italic', 'underline', 'strike'],        // 加粗 斜体 下划线 删除线
            [{'color': []}, {'background': []}],          // 字体颜色、字体背景颜色

            // 第二行
            [{'header': 1}, {'header': 2}, {'header': 3}, {'header': [1, 2, 3, 4, 5, 6, false]}], // 标题
            [{'size': ['small', false, 'large', 'huge']}],  // 字体大小
            [{'font': []}],                                 // 字体种类

            // 第三行
            [{'list': 'ordered'}, {'list': 'bullet'}],     // 有序、无序列表
            [{'align': []}],                                // 对齐方式
            ['blockquote', 'code-block'],                      // 引用、代码块

            // 第四行
            [{'script': 'sub'}, {'script': 'super'}],      // 上标/下标
            [{'indent': '-1'}, {'indent': '+1'}],          // 缩进
            [{'direction': 'rtl'}],                         // 文本方向
            ['link'],                                         // 链接（移除了image）
            ['clean']                                         // 清除文本格式
          ]
        },
        placeholder: '请输入内容...'
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal !== this.content) {
        this.content = newVal
      }
    },
    content(newVal) {
      this.$emit('input', newVal)
    }
  },
  methods: {
    onEditorBlur(editor) {
      this.$emit('blur', editor)
    },
    onEditorFocus(editor) {
      this.$emit('focus', editor)
    },
    onEditorReady(editor) {
      this.$emit('ready', editor)
    }
  }
}
</script>

<style scoped>
.xr-editor {
  width: 100%;
}

.ql-container {
  height: auto;
  min-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/XrEditor/index.vue